'use strict';

angular.module('magview')
  .controller('TimeTrackingCtrl', [
    '$scope', 'TimeTrackingViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.selectedUserId);
    }
  ]);
